import CustomView from "@/domain/entities/customViews/CustomView";
import { useToast } from "@/hooks/utils/useToast";
import { queryKeys } from "@/lib/queryKeys";
import { customViewToDomainMapper } from "@/mappers/customView/customViewMapper";
import {
    CustomView as CustomViewSDK,
    useCustomViews,
} from "@cs_teamwaydev/mailvista-sdk_react";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

const useGetView = (viewId?: string) => {
    const customViews = useCustomViews();
    const { toast } = useToast();
    const { t } = useTranslation();

    const fetchView = async (): Promise<CustomView | undefined> => {
        if (!viewId) {
            throw new Error("View ID is undefined");
        }

        try {
            const view: CustomViewSDK = await customViews.getView(viewId);
            if (!view) {
                throw new Error("View not found");
            }

            return customViewToDomainMapper(view);
        } catch (error) {
            console.error(error);
            toast({
                title: t("errors.customViews.getView"),
                description: t("errors.global.description"),
                variant: "error",
            });
            throw error;
        }
    };

    const getView = useQuery({
        queryKey: queryKeys.customView.detail(viewId!),
        queryFn: () => fetchView(),
        enabled: !!viewId,
    });

    return getView;
};

export default useGetView;
